import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IZeitUnterartsQueryShapes, ZeitUnterartsQueryFilterConfig } from 'fa-kt.types';
import { ZeitUnterartsService } from '../service';

@Component({
  selector: 'fa-kt-zeit-unterarts-filter',
  templateUrl: './zeit-unterarts-filter.component.html',
  styleUrls: ['./zeit-unterarts-filter.component.css'],
})
export class ZeitUnterartsFilterComponent {
  readonly subscriptions: Subscription[] = [];

  ZeitUnterartsFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public zeitUnterarts: ZeitUnterartsService,
  ) {
    this.ZeitUnterartsFilterConfig = ZeitUnterartsQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.zeitUnterarts.shapes$.subscribe((shapes: IZeitUnterartsQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ZeitUnterartsFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ZeitUnterartsFilterConfig[index].selections = shapes;
  }
}
